import { render, staticRenderFns } from "./InfractionNoticesList.vue?vue&type=template&id=1ed4297c&"
import script from "./InfractionNoticesList.vue?vue&type=script&lang=js&"
export * from "./InfractionNoticesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports